import {MATRIX4} from '../../index.js';

/**
 * Abstract Hypercube.js camera.
 * @example
 * class CameraExample extends Camera {
 *
 *     get projection() {
 *
 *         // must be implemented
 *     }
 * }
 */
class Camera {

    /**
     * Stores the aspect ratio (width / height).
     * @type {number}
     * @protected
     */
    $aspect;

    /**
     * Stores the name.
     * @type {string}
     * @private
     */
    $name;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type;

    /**
     * Gets the name.
     * @type {string}
     * @public
     * @readonly
     */
    get name() {

        return this.$name;
    }

    /**
     * Gets the projection matrix of the camera.
     * @type {matrix4}
     * @public
     * @readonly
     */
    get projection() {

        console.warn('Hypercube.js - Camera - get projection() - NOT IMPLEMENTED');

        return MATRIX4.identity();
    }

    /**
     * Gets the type.
     * @type {string}
     * @public
     * @readonly
     */
    get type() {

        return this.$type;
    };

    /**
     * Creates a new Hypercube.js camera.
     * @param {string} [$name] The name of the camera.
     */
    constructor($name = 'Camera') {

        this.$name = $name;
    }

    /**
     * Sets the aspect ratio.
     * @param {number} $aspect The aspect ratio (width / height) to set.
     * @public
     */
    setaspect($aspect) {

        this.$aspect = $aspect;
    }
}

export {

    Camera
};

export default Camera;
